import * as React from 'react';
import { Root, Img, Title, HelperText } from './styled';

interface SearchResultBaseProps {
    title: React.ReactNode;
    helperText: React.ReactNode;
    imageSrc: string;
    className?: string;
}

const SearchResultBase: React.StatelessComponent<SearchResultBaseProps> = ({
    title,
    helperText,
    imageSrc,
    ...props
}) => (
    <Root {...props}>
        <Img src={imageSrc} />
        <Title>{title}</Title>
        <HelperText>{helperText}</HelperText>
    </Root>
);

export default SearchResultBase;
